// ─── Quale versione sta girando ──────────────────────────────────────────────
//
// ⭐ IL NUMERO NON È CABLATO NEL FRONTEND, SI CHIEDE AL SERVER. Arriva da
// `GET /api/v1/health`, che risponde con `APP_VERSION` — cioè con il tag che ha
// acceso la costruzione dell'immagine (`ARG VERSION` nel Dockerfile). ⇒ Il
// numero scritto nella barra è quello dell'immagine viva nel cluster, non un
// numero scritto a mano in un file che un giorno qualcuno dimentica di
// aggiornare.
//
// ⚖️ Frontend e API stanno nella STESSA immagine — Fastify serve `./public` —
// quindi «la versione dell'API» e «la versione della pagina» sono lo stesso
// numero. Se un giorno si separassero, questa riga andrebbe rifatta, perché
// direbbe la versione del server a chi guarda la pagina.
//
// 🚨 In sviluppo vale `0.0.0-dev`, che è il valore predefinito della
// configurazione: non è un guasto, è il modo di distinguere a colpo d'occhio
// una pagina servita dal cluster da una servita da Vite.

import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '@pmo/shared';
import { chiama } from '../lib/api.js';

/** La versione viva, o `null` finché il server non ha risposto. */
export function usaVersione(): string | null {
  const q = useQuery({
    queryKey: ['versione'],
    queryFn: () => chiama<HealthResponse>('GET', '/health'),
    // Una versione non cambia mentre la pagina è aperta: cambiarla vorrebbe
    // dire che l'immagine sotto i piedi è stata sostituita, e in quel caso la
    // pagina va comunque ricaricata. ⇒ Si chiede una volta e basta.
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
  return q.data?.version ?? null;
}
